import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

import {
  computed, withDefaults,
} from 'vue';
import SwNavbarButton from '@/components/molecules/Buttons/SwNavbarButton.vue';
import { ColorType, IconType } from '@/types/ui-components';

export type NavbarMenuItemType = {
  to?: string;
  label?: string;
  icon? : IconType;
};
export type NavbarMenuItemColorType = 'primary' | 'white' | 'gray';

interface Props {
  items: NavbarMenuItemType[];
  color?: ColorType;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SwNavbarButtons',
  props: {
    items: null,
    color: { default: 'primary' }
  },
  setup(__props: any) {

const props = __props as { items: NavbarMenuItemType[], color: ColorType }



/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-navbar-menu-items': true,
  [`sw-navbar-menu-items--${props.color || 'primary'}`]: true,
}));

return (_ctx: any,_cache: any) => {
  return (__props.items)
    ? (_openBlock(), _createElementBlock("ul", {
        key: 0,
        class: _normalizeClass(_unref(classes))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index + '_' + item.label,
            class: "sw-navbar-menu-items--item"
          }, [
            _createVNode(SwNavbarButton, {
              label: item.label,
              icon: item.icon,
              to: item.to,
              color: __props.color
            }, null, 8, ["label", "icon", "to", "color"])
          ]))
        }), 128))
      ], 2))
    : _createCommentVNode("", true)
}
}

})